import { render, staticRenderFns } from "./FreeAccountExpired.vue?vue&type=template&id=6e8b1a80&scoped=true"
import script from "./FreeAccountExpired.vue?vue&type=script&lang=js"
export * from "./FreeAccountExpired.vue?vue&type=script&lang=js"
import style0 from "./FreeAccountExpired.vue?vue&type=style&index=0&id=6e8b1a80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b1a80",
  null
  
)

export default component.exports